import React from 'react';
import notify from '@/lib/notify';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Input from '../Forms/Input';
import Select from '../Forms/Select';
import { Button } from '../Common/button';

interface InviteFormData {
  email: string;
  role: string;
}

const InviteUserForm: React.FC = () => {
  const { t } = useTranslation();
  const { register, handleSubmit, formState: { errors }, reset } = useForm<InviteFormData>({
    defaultValues: {
      email: '',
      role: ''
    }
  });

  const roleOptions = [
    { value: "", label: t('settings.inviteForm.selectRole'), disabled: true },
    { value: "admin", label: t('settings.inviteForm.roles.admin') },
    { value: "member", label: t('settings.inviteForm.roles.member') },
    { value: "viewer", label: t('settings.inviteForm.roles.viewer') },
  ];

  const onSubmit: SubmitHandler<InviteFormData> = data => {
    console.log('Invitation Data:', data);
    notify.info(t('settings.inviteForm.simulatedSent', { email: data.email, role: data.role }));
    reset();
  };

  return (
    <div className="rounded-lg border border-border bg-card p-6 mt-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">{t('settings.inviteCollaborator')}</h3>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <Input
          label={t('settings.inviteForm.emailLabel')}
          name="email"
          id="invite-email"
          type="email"
          register={register}
          rules={{
            required: t('settings.inviteForm.emailRequired'),
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: t('settings.inviteForm.emailInvalid')
            }
          }}
          error={errors.email}
        />
        <Select
          label={t('settings.role')}
          name="role"
          id="invite-role"
          options={roleOptions}
          register={register}
          error={errors.role}
        />
        <Button type="submit" className="w-full sm:w-auto">{t('settings.inviteForm.submit')}</Button>
      </form>
    </div>
  );
};

export default InviteUserForm;
